/**
 * Print states a pickup can be in.
 *
 * Mirrors `OrderPickingEnum` on the backend. Worth being explicit about what
 * this tracks: it is the state of the **label's print job**, not of the
 * collection — a pickup exists only because a driver already scanned the order
 * at the CD, so there is no "scheduled" or "cancelled" to show.
 *
 * Copied from the enum rather than from the legacy front, where the labels live
 * duplicated in two places with different casing (`Picking.jsx` and
 * `utils/functions.js`) and unknown values silently render as "Pendiente".
 */
export const PICKING_STATES = [
  { value: 'pending', label: 'Pendiente', color: '#3b82f6' },
  { value: 'ready_to_print', label: 'Listo para imprimir', color: '#f59e0b' },
  { value: 'send_to_client', label: 'En cola de impresión', color: '#8b5cf6' },
  { value: 'printed', label: 'Impreso', color: '#10b981' },
  { value: 'failed', label: 'Fallido', color: '#ef4444' },
];

/** Keyed by backend value, for the badge in the table. */
export const PICKING_STATE_MAP = PICKING_STATES.reduce((map, state) => {
  map[state.value] = state;
  return map;
}, {});

/** Options for the status filter, with the "no filter" sentinel up front. */
export const PICKING_STATE_OPTIONS = [
  { value: 'all', label: 'Todos' },
  ...PICKING_STATES.map(({ value, label }) => ({ value, label })),
];
